const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default email => {
    return re.test(email);
};



// WEBPACK FOOTER //
// ./src/utils/validateEmail.js